import { AxiosResponse } from 'axios'
import { api } from 'API'
import { IFeedback } from 'interfaces/feedback'

export async function createFeedback(data: Partial<IFeedback>): Promise<IFeedback> {
  const response: AxiosResponse = await api.post(`/feedbacks`, data)
  return response?.data
}

export async function updateFeedback(id: number, data: Partial<IFeedback>): Promise<IFeedback> {
  const response: AxiosResponse = await api.patch(`/feedbacks/${id}`, data)
  return response?.data
}
